import { render, staticRenderFns } from "./StatBlock.vue?vue&type=template&id=23412385&"
import script from "./StatBlock.vue?vue&type=script&lang=js&"
export * from "./StatBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports